import React from "react";
import NavBar from "./NavBar";
import Updates from "./Updates";
import "./Updates.css";

function NewUpdates() {
  return (
    <div>
      <div>{/* <NavBar /> */}</div>
      <div>
        <div>
          <Updates />
        </div>
      </div>
    </div>
  );
}

export default NewUpdates;
